import moment from 'moment';
import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import userService from "../../service/UserService";
import { Button, Col, Container, Dropdown, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import swal from 'sweetalert';
import { ThreeDotSpinner } from '../../common/loader/loader';
import { kycStatusMap } from '../../common/constant';

export const ViewUsers = () => {

  const [role, setRole] = useState('USER')
  const [filter, setFilter] = useState({ status: null, search : null})
  const [Loader, setLoader] = useState(false)
  const [users, setUsers] = useState([])
  const [pagination, setPagination] = useState({ pageNumber: 1, pageSize: 10, pageRange: 0, totalCount: 0 })

  useEffect(() => {
    fetchUsers()
  }, [role, pagination.pageNumber, filter.status])

  const fetchUsers = async () => {
    setLoader(true);
    const params = { role: role, kycStatus: filter.status, search : filter.search, page: pagination.pageNumber - 1, size: pagination.pageSize }
    const response = await userService.filter(params);
    if (response.status == 200) {
      setLoader(false);
      setUsers(response.data.data.users)
      setPagination({
        ...pagination,
        totalCount: response.data.data.count
      })
    }
  }

  const applySearch = (e) => {
    let query = e.target.value.trim()
    if(query=='') query = null
    setFilter({...filter, search: query})
  } 

  const applyFilter = (e) => {
    let query = e.target.value.trim()
    if(query=='' || query=='all') query = null
    setFilter({...filter, status: query})
  } 

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchUsers()
    }, 1000); // 1000ms delay

    return () => clearTimeout(delayDebounce);
  }, [filter.search]);

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      View
    </Tooltip>
  );

  const renderToggleTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      enable/disable
    </Tooltip>
  );

  const onRoleChange = (role) => {
    setRole(role);
    setFilter({status : null,search : null})
    setPagination({
      ...pagination,
      pageNumber: 1
    })
  }

  const handlePageChange = (pageNumber) => {
    setPagination({
      ...pagination,
      pageNumber: pageNumber
    })
  };

  const onUserStatusChange = async (userId) => {
    const response = await userService.updateStatus(userId);
    if (response.status == 200) {
      swal({ icon: 'success', text: response.data.message, button: "OK" });
      fetchUsers();
    }
  }

  return (
    <>
      {Loader && <ThreeDotSpinner />}
      <div className="dashboard-main-area">
        <Container fluid>
          <div className="dashboard-area-heading management-heading">

            <Row className="row justify-content-center align-items-center mb-2">
              <Col md={12}>
                <div className="d-flex justify-content-between mb-2">
                  <div className="d-flex ">
                    <h2 className="align-self-center m-0">{role.charAt(0).toUpperCase() + role.slice(1).toLowerCase()} Management</h2>
                  </div>
                  <div className='d-flex justify-content-center gap-2'>

                  <div className='filter-section d-flex gap-2'>
                      <div className='position-relative'>
                        <i class="fa fa-search position-absolute w-100" aria-hidden="true"></i>
                        <input type='text' className='form-control' placeholder='Search by name...' onInput={ applySearch } />
                      </div>
                    { role == 'VALIDATOR' &&
                      <select className='form-select' onChange={ applyFilter }>
                        <option value='all'>All</option>
                        {
                          Object.entries(kycStatusMap).map((entry, index) => (
                            <option value={entry[0]}>{ entry[1] }</option>
                          ))
                        }
                      </select>
                    }
                    </div>

                    <div className="user-list-top-btn">
                      <Button type="button" variant="unset" className={role == 'USER' ? 'individual-btn' : 'individual-btn active'} onClick={() => onRoleChange('USER')}><i className="fas fa-user"></i> User</Button>
                      <Button type="button" variant="unset" className={role == 'VALIDATOR' ? 'individual-btn' : 'individual-btn active'} onClick={() => onRoleChange('VALIDATOR')}><i className="fas fa-users"></i> Validator</Button>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="pb-4 justify-content-center">
              <Col md={12}>
                <div className="audit-request-box">
                  <Table responsive="sm" className="UserListTable">
                    <thead>
                      <tr>
                        <th>Creation Date</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        {role == 'VALIDATOR' && (
                          <th>KYC Status</th>
                        )}
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        users.map((user, index) => (
                          <tr key={index}>
                            <td>{moment(user.createdAt).format('DD-MM-YYYY')}</td>
                            <td>{user.fullName}</td>
                            <td>{user.email}</td>
                            <td>{user.phone}</td>
                            {role === "VALIDATOR" && (
                              <td>{kycStatusMap[user.kycStatus] || user.kycStatus}</td>
                            )}

                            <td>
                              <div className="action-boxes">
                                <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={renderTooltip}
                                >
                                  <Link to={`/users/${user._id}`}>
                                    <div className="view-btn-main" style={{ cursor: "pointer" }}>
                                      <i className="fa-solid fa-eye"></i>
                                    </div>
                                  </Link>
                                </OverlayTrigger>

                                <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={renderToggleTooltip}
                                >
                                  <Form.Check
                                    type="switch"
                                    id={`custom-switch-${user._id}`}
                                    onClick={() =>
                                      swal({
                                        title: "Confirm",
                                        text: `Are you sure you want to ${user?.enabled ? "disable user?" : "Enable user?"}`,
                                        icon: "warning",
                                        buttons: {
                                          cancel: "Cancel",
                                          confirm: "Yes"
                                        },
                                      }).then((value) => {
                                        if (value) {
                                          { onUserStatusChange(user._id) }
                                        } else {
                                          console.log("NO button clicked or popup closed");
                                        }
                                      })
                                    }
                                    checked={user?.enabled}
                                  />
                                </OverlayTrigger>
                              </div>
                            </td>

                          </tr>
                        ))
                      }

                      {pagination.totalCount == 0 &&

                        <tr className="no-dat-found-box">
                          <td colSpan={10}>
                            <img src={require("../../assets/images/no-data-bg.gif")} alt="no-data-image" />
                            <h3 className="text-center">
                              No data found
                            </h3>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </Table>

                  {pagination.totalCount > pagination.pageSize &&
                    <Pagination
                      activePage={pagination.pageNumber}
                      itemsCountPerPage={pagination.pageSize}
                      totalItemsCount={pagination.totalCount}
                      pageRangeDisplayed={pagination.pageRange}
                      onChange={(e) => handlePageChange(e)}
                      prevPageText={"Prev"}
                      nextPageText={"Next"}
                    />
                  }
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};
